import type { VAxios } from '../../define/axios/Axios';
import {
  ArticlePagesRes,
  DetailsRes,
  GetNewArticlesRes,
} from '../../entities/website/articles.entities';

/**
 * 登录相关接口
 */
export const createApi = (defHttp: VAxios) => ({
  // 获取文章列表
  pages: (params: {
    page: number;
    pageSize: number;
    sortField?: string;
    sortOrder?: string;
    typeId: string | number;
  }) => {
    return defHttp.get<ArticlePagesRes>({
      url: `/website/articles`,
      params,
    });
  },

  // 获取最新3篇文章列表
  getNewArticles: (params: {
    page: number;
    pageSize: number;
    sortField?: string;
    sortOrder?: string;
    typeId?: number;
  }) => {
    return defHttp.get<GetNewArticlesRes>({
      url: `/website/articles/latest`,
      params,
    });
  },
  // 获取文章详情
  details: (id: string) => {
    return defHttp.get<DetailsRes>({
      url: `/website/articles/${id}`,
    });
  },
});
